import { SET_LOGS } from '../constants/LogConstants';

const initialState = {
  logs: {
    list: [],
    count: 0,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOGS: {
      return {
        ...state,
        logs: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    default: {
      return state;
    }
  }
}
